export default __webpack_public_path__ + "static/media/qr_appstore_yokara.27170f81.svg";